module.exports = __webpack_public_path__ + "img/logo-stenci.97e33be0.svg";